import React from "react";
import { Link } from "react-router-dom";
import styles from "./style.module.scss";

function Footer({customClass,children}) {
  return (
    <div className={`${styles.links} ${customClass ? customClass :""}`}>
      {children}
      <div>
      <Link to={"#"}onClick={(e) => {
          window.location.href = "mailto:support@fanzpick.com";
                e.preventDefault();
        }} className={styles.fanzinfo}>support@fanzpick.com</Link>
      <Link to={"/"}>Home</Link>
      <Link to={"/about-us"}>About Us</Link>
      <Link to={"/faq"}>FAQ's</Link>
      <Link to={"/privacy-policy"}>Privacy Policy</Link>
      
      {/* <Link to={"/support"}>Support</Link> */}
      </div>
    </div>
  );
}

export default Footer;
